export const SITE_MAP_GET_SITE_MAP_BEGIN = 'SITE_MAP_GET_SITE_MAP_BEGIN';
export const SITE_MAP_GET_SITE_MAP_SUCCESS = 'SITE_MAP_GET_SITE_MAP_SUCCESS';
export const SITE_MAP_GET_SITE_MAP_FAILURE = 'SITE_MAP_GET_SITE_MAP_FAILURE';
export const SITE_MAP_GET_SITE_MAP_DISMISS_ERROR = 'SITE_MAP_GET_SITE_MAP_DISMISS_ERROR';



// WEBPACK FOOTER //
// ./src/features/site-map/redux/constants.js